module.exports = __webpack_public_path__ + "assets/img/19_743_big.5243dc16.jpg";